import { useState } from "react";
import { auth } from "../lib/api";

export function Login({ onAuthed }: { onAuthed: (user: string) => void }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    const ok = await auth.login(username, password);
    setBusy(false);
    // The server deliberately does not distinguish "no such user" from "wrong
    // password", and neither does this message.
    if (ok) onAuthed(username);
    else setError("Invalid credentials.");
  }

  return (
    <div className="h-full grid place-items-center">
      <form
        onSubmit={submit}
        className="w-[320px] border border-term-edge bg-term-panel p-6 rounded"
      >
        <div className="text-term-text text-base mb-1">srank</div>
        <div className="text-term-dim text-[11px] mb-6">
          Point-in-time equity factor research
        </div>

        <label className="block text-[11px] text-term-dim mb-1">User</label>
        <input
          autoFocus
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          className="w-full mb-3 bg-term-bg border border-term-edge rounded px-2 py-1.5
                     outline-none focus:border-term-accent"
        />

        <label className="block text-[11px] text-term-dim mb-1">Password</label>
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="w-full mb-4 bg-term-bg border border-term-edge rounded px-2 py-1.5
                     outline-none focus:border-term-accent"
        />

        {error && <div className="text-term-down text-[11px] mb-3">{error}</div>}

        <button
          type="submit"
          disabled={busy || !username || !password}
          className="w-full bg-term-accent/90 hover:bg-term-accent disabled:opacity-40
                     text-white rounded py-1.5 transition-colors"
        >
          {busy ? "…" : "Sign in"}
        </button>
      </form>
    </div>
  );
}
